import { render, staticRenderFns } from "./ReasonForHangingUp.vue?vue&type=template&id=81cf1a60&scoped=true"
import script from "./ReasonForHangingUp.vue?vue&type=script&lang=js"
export * from "./ReasonForHangingUp.vue?vue&type=script&lang=js"
import style0 from "./ReasonForHangingUp.vue?vue&type=style&index=0&id=81cf1a60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cf1a60",
  null
  
)

export default component.exports